import { I18nData } from "../../form.util";

export type SalesAgentProps = {
  refId: string;
};

export type AgentProfile = {
  name: I18nData[];
  agentCode: string;
  profilePictureUrl: string;
  license: License[];
  domicile: string;
};

export type License = {
  licenseType: string;
  licenseNumber: string;
  cpdCode: string;
  licenseExpiredDate: string;
};

export enum LICENSE_TYPE {
  AAJI = "AAJI",
  AASI = "AASI",
}
